import { initSlider } from './init-slider';
import 'magnific-popup';

// Slider default
const $slider = $('.js-slider');
const sliderOptions = {
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000
};

initSlider($slider, sliderOptions);

// Slider with products

const $sliderItems = $('.js-slider-items');
const sliderItemsOptions = {
  dots: false,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

initSlider($sliderItems, sliderItemsOptions);

// Thumbs

const $thumbs = $('.js-thumbs');
const thumbsOptions = {
  variableWidth: false,
  focusOnSelect: true,
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 7,
  slidesToScroll: 1,
  centerMode: false,
  asNavFor: '.js-slider-product',
  responsive: [
    {
      breakpoint: 1107,
      settings: {
        slidesToShow: 5
      }
    }
  ]
};

initSlider($thumbs, thumbsOptions);

// Slider product images

const $sliderProduct = $('.js-slider-product');
const sliderProductOptions = {
  dots: false,
  arrows: false,
  infinite: false,
  asNavFor: '.js-thumbs',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
        arrows: true
      }
    }
  ]
};

initSlider($sliderProduct, sliderProductOptions);

$sliderProduct.on('afterChange', function(event, slick, currentSlide) {
  const $currentSlide = $(this).find('.slick-current');

  if ($currentSlide.find('.js-popup-video')) {
    $currentSlide.find('.js-popup-video').trigger('click');
  }
});

// Gallery images
$('.js-gallery').magnificPopup({
  delegate: '.slick-slide:not(.slick-cloned) .slider__slide-link',
  type: 'image',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0, 1]
  }
});

// Slider Testimonials
const $sliderTestimonials = $('.js-slider-testimonials');
const sliderTestimonialsOptions = {
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
  adaptiveHeight: true
};

initSlider($sliderTestimonials, sliderTestimonialsOptions);



// WEBPACK FOOTER //
// ./../src/assets/js/slider.js